import * as React from 'react'
import accessStore from "../../../services/locations/AccessStore";
import { MetricDelta } from "../../../components/reports/MetricDelta";
import { GroupToggle } from "./GroupToggle";
import { PurtyNumber } from "../../../components/reports/PurtyNumber";
import getClassName from "../../../util/styles/getClassName"

export const ReportRow = ({ result, entity, index, expandRow, showGroups, columns, levelsDeep }) => {
  const nestingStyle = showGroups ? { paddingLeft: `${1.25 * (levelsDeep + 1)}rem` } : {};
  const hasAddress = !entity ? null : !entity.address ? null : entity.address;
  const addressLine1 = !hasAddress ? "" : `${entity.address.streetAddress || ""}`;
  const addressLine2 = !hasAddress ? "" : `${entity.address.addressLocality || ""}, ${!entity.address.addressRegion ? "" : entity.address.addressRegion.length === 2 ? entity.address.addressRegion.toUpperCase() : entity.address.addressRegion} ${entity.address.postalCode || ""}`;
  return (
    <React.Fragment>
      <tr key={'report-body-row-' + result.entityId}>
        <td className="text-truncate" style={{ ...nestingStyle, maxWidth: '180px' }}>
          {result.isGroup
            ?
            <GroupToggle
              row={result}
              name={entity ? entity.name : 'All'}
              index={index} expanded={result.expanded}
              isLoading={result.isLoading}
              onClick={() => expandRow(index, result, levelsDeep)}
            />
            :
            <React.Fragment>
              <div className="font-weight-bold text-truncate">
                {!entity ? "" : entity.name}
              </div>
              <div className="text-capitalize text-truncate">
                {addressLine1}
              </div>
              <div className="text-capitalize text-truncate">
                {addressLine2}
              </div>
            </React.Fragment>}
        </td>
        {columns.filter(column => !!column.sortable && column.id !== 'locations' && !column.id.includes('Topic')).map(column => {
          const value = !!result.values ? result.values[column.id] : { current: 0, decimalDelta: 0 };
          let showNan = (!value.current || value.current === 0) && column.showNAForZero;
          return (
            <td key={'report-body-col-' + result.entityId + '-' + column.id} className={`${getClassName(column.id, /(?=[A-Z])/)} ${showNan ? "text-muted" : ""}`}>
              <span className="d-flex flex-row justify-content-center">
                <span className="d-flex align-items-center justify-content-end left-value">
                  <PurtyNumber
                    value={value.current !== false && value.current}
                    defaultValue={showNan ? "N/A" : value.current}
                    numberOfDecimalPlaces={column.numberOfDecimalPlaces}
                  />
                </span>
                {!showNan && <span className="d-flex align-items-center justify-content-end right-value">
                  <MetricDelta
                    decimalDelta={value.decimalDelta}
                    showDeltaWithColor={column.showDeltaWithColor} 
                    />
                </span>}
              </span>
            </td>
          )
        })}
        <td className="positive">
          <TopTopics topTopics={result.topPositiveTopic} entityId={result.entityId} polarity={'positive'} />
        </td>
        <td className="negative">
          <TopTopics topTopics={result.topNegativeTopic} entityId={result.entityId} polarity={'negative'} />
        </td>
      </tr>
      {result.expanded && result.children && result.children.map((childResult, childIndex) => {
        return <ReportRow key={'report-row-child-l-' + levelsDeep + 1 + '-' + childIndex} result={childResult} entity={accessStore && accessStore.byEntityId[childResult.entityId]}
          showGroups={showGroups} columns={columns}
          expandRow={expandRow} index={childIndex} levelsDeep={levelsDeep + 1} />
      })}
    </React.Fragment>
  )
}

const topTopicClass = {
  'positive': 'positive',
  'negative': 'negative',
}

const TopTopics = ({ topTopics, entityId, polarity }) => {
  let item = topTopics;
  const topAtt = !!item && !!item.children && !!item.children.length > 0 && item.children[0];
  const clazz = `${!!item && topTopicClass[polarity]} ${!item ? " text-muted" : ""}`;

  return (
    <div className="d-flex flex-column justify-content-center">
      <div key={'top-topic-' + entityId} className="d-flex justify-content-center">
        { /* TODO: Switch this to a MetricDelta when we have a sense of trending. */}
        <span className={`pr-1 text-right text-capitalize sentiment ${clazz} topic-word`}>{!!item ? item.name : "N/A"}</span>
        <span className="topic-count text-left">
          {!!item && `(${item.count.toLocaleString()})`}
        </span>
      </div>

      <div key={'top-attribute-' + entityId} className="d-flex justify-content-center">
        <span className={`pr-1 sentiment topic-word`}>{!!topAtt ? topAtt.name : "N/A"}</span>
        <span className="topic-count">
          {!!topAtt && `(${topAtt.count.toLocaleString()})`}
        </span>
      </div>
    </div>
  )
}